import React from 'react';
import BaseQuiz, { QuizQuestion, UserAnswer } from './BaseQuiz';
import { savePatientQuizResults } from '../../api/patient.api';
import OraChatBot from '../appContents/OraChatBot/OraChatBot';
import './Quiz.scss';

const myQuestions: QuizQuestion[] = [
    {
        id: 'q1',
        question: 'Physical therapy and exercises can help improve strength and flexibility reducing pain and improving function.',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q2',
        question: 'Surgery has the risk of infection, wearing out of the artificial knee and anesthetic risks',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q3',
        question: 'Cortisone is an anti-inflammatory that can be injected into the knee joint to reduce pain and swelling',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q4',
        question: 'Total knee replacement is a good option for patients with mild arthritis',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'False',
        required: true,
    },
    {
        id: 'q5',
        question: 'Over-the counter pain relievers and anti-inflammatory medication is a good first treatment for osteoarthritis of the knee',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q6',
        question: 'Losing weight and switching from high-impact activities (jogging, tennis) to low-impact activities can decrease pain',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q7',
        question: 'PRP contains "growth factors" that may help reduce inflammation in knee osteoarthritis but is not a proven treatment',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
    {
        id: 'q8',
        question: 'NSAID\'s should be used with caution in patients with GI issues, coronary artery disease, and kidney problems.',
        type: 'single',
        options: [ 'True', 'False' ],
        correctAnswer: 'True',
        required: true,
    },
];

export default function Quiz() {
    const handleComplete = async (answers: UserAnswer[]) => {
        await savePatientQuizResults(answers.map((answer) => (
            {
                question: answer.question,
                patientAnswer: answer.questionAnswer,
                correctAnswer: answer.questionCorrectAnswer || '',
            }
        )));

    };

    return (
        <div className="custom-quiz">
            <OraChatBot pageTitle="Osteoarthritis"/>
            <BaseQuiz
                questions={myQuestions}
                onQuizComplete={handleComplete}
            />
        </div>
    );
}